import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { AlertMessageType } from '@ux/components/alert-message/alert-message-type';
import { FormInputType, FormDocumentInputTemplate } from '@forms/form-text-input/entities/input-type';
import { FormValidationService } from '@reservation/services/form-validation.service';
import { ButtonType } from '@design-system/components/molecules/button/entities/button.types';

@Component({
  selector: 'app-marriott-bonvoy-form',
  templateUrl: './marriott-bonvoy-form.component.html',
  styleUrls: ['./marriott-bonvoy-form.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MarriottBonvoyFormComponent implements OnInit  {

  @Input() form: UntypedFormGroup;
  @Input() defaultValue: string;
  @Input() defaultPaxFullName: string;
  @Input() isMobile: boolean;
  @Input() suggestedValue: string;
  @Input() isLoadingPaxForm: boolean;

  @Output() updateMarriottBonvoyNumber: EventEmitter<string> = new EventEmitter<string>();
  @Output() createMarriottBonvoyNumber: EventEmitter<void> = new EventEmitter<void>();

  public alertType: AlertMessageType = AlertMessageType.WARNING;
  public marriottForm: UntypedFormGroup;
  public flyerSelector = 'marriottBonvoyNumber';
  public isSubmitted = false;
  public documentInput: FormInputType = FormInputType.DOCUMENT;
  public alphanumericType: FormDocumentInputTemplate = FormDocumentInputTemplate.ALPHANUMERIC;

  public readonly becomeMemberButtonType = ButtonType.Secondary;

  constructor(
    private readonly formValidationService: FormValidationService,
  ) { }

  ngOnInit(): void {
    this.createLoyaltyForm();
  }

  public createLoyaltyForm(): void {
    this.marriottForm = new UntypedFormGroup({
      marriottBonvoyNumber: new UntypedFormControl(this.defaultValue, [
        Validators.required, Validators.minLength(3)
      ]),
    });
  }

  public save(): void {
    this.isSubmitted = true;
    if (!this.formValidationService.formInvalidControls(this.marriottForm)) {
      const values = this.marriottForm.value;
      this.updateMarriottBonvoyNumber.emit(values.marriottBonvoyNumber);
    }
  }
}
